// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyA4zXgQklMFHNyGjJLeleIjYaNT-dRdJFM",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "centron-db93f.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "centron-db93f",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "centron-db93f.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "378530802083",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:378530802083:web:81b495c12bb7ae2b1d9216",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-TMELKX5PRH"
};

// Debug: Log configuration in development
if (process.env.NODE_ENV === 'development') {
  console.log('Firebase Config:', {
    apiKey: firebaseConfig.apiKey ? '***' : 'MISSING',
    authDomain: firebaseConfig.authDomain,
    projectId: firebaseConfig.projectId,
    storageBucket: firebaseConfig.storageBucket,
    messagingSenderId: firebaseConfig.messagingSenderId,
    appId: firebaseConfig.appId,
    measurementId: firebaseConfig.measurementId
  });
}

// Initialize Firebase
let app;
try {
  app = initializeApp(firebaseConfig);
  console.log('Firebase initialized successfully');
} catch (error) {
  console.error('Firebase initialization failed:', error);
  throw error;
}

// Initialize Firebase services
let analytics = null;
let db = null;
let auth = null;
let storage = null;

try {
  // Only initialize analytics in production and if measurementId is available
  if (process.env.NODE_ENV === 'production' && firebaseConfig.measurementId) {
    analytics = getAnalytics(app);
  }
  
  db = getFirestore(app);
  auth = getAuth(app);
  storage = getStorage(app);
  
  // Connect to emulator in development if needed
  if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_FIRESTORE_EMULATOR) {
    connectFirestoreEmulator(db, 'localhost', 8080);
    console.log('Connected to Firestore emulator');
  }
  
  console.log('Firebase services initialized successfully');
} catch (error) {
  console.error('Firebase services initialization failed:', error);
  throw error;
}

// Export a function to check if Firebase is ready
export const isFirebaseReady = () => {
  return !!(app && db && auth);
};

export { app, analytics, db, auth, storage }; 